import { UserProfile } from './../../../../model/user';
import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { Utils } from '@app-shared/utils';
import { SidebarService } from '@app-services/sidebar.service';
import { UniversalStorage } from '@aws-amplify/core';
import { SessionService } from '@app-store/session/session.service';
import { canViewFloDashboard } from '@app/guards/flo-admin.guard';

@Component({
    selector: 'app-layout-restrict-area-sidebar',
    templateUrl: './layout-restrict-area-sidebar.component.html',
    styleUrls: ['./layout-restrict-area-sidebar.component.scss'],
    standalone: false
})
export class LayoutRestrictAreaSidebarComponent implements OnInit {
	isMobile = false;
	isAdmin = false;
	@Input() userProfile: UserProfile;

	itemsMenu = [
		{
			type: 'link',
			label: 'HOME',
			icon: 'fa-home',
			link: 'home',
			dropdown: false,
			children: []
		},
		{
			id: 'visualIdentity',
			type: 'dropdown',
			label: 'SETUP DA EMPRESA',
			icon: 'fa-paint-brush',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Configurar Empresa',
					link: 'configurar-empresa',
					justAdmin: true,
				},
				{
					type: 'link',
					label: 'Personalizar Cor',
					link: 'identidade-visual'
				},
				{
					type: 'link',
					label: 'Personalizar Logo',
					link: 'identidade-visual-logo'
				},
			]
		},
		{
			id: 'users',
			type: 'dropdown',
			label: 'USUÁRIOS',
			icon: 'fa-user',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Lista de Usuários',
					link: 'users/list'
				},
				{
					type: 'link',
					label: 'Upload de Base',
					link: 'database-upload'
				},
				{
					type: 'link',
					label: 'Ranking da Gamificação',
					link: 'ranking-gamificacao'
				},
				{
					type: 'link',
					label: 'Relatório de Vacinas',
					link: 'users/vaccine'
				},
				{
					type: 'link',
					label: 'Relatório COVID-19',
					link: 'users/user-covid',
					hasCovidEnabled: true
				},
				{
					type: 'link',
					label: 'Relatório de Administradores',
					link: 'users/managers'
				}
			]
		},
		{
			id: 'step-counter',
			type: 'dropdown',
			label: 'CONTADOR DE PASSOS',
			icon: 'fa-shoe-prints',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Relátorios',
					link: 'step-counter/report'
				},
				{
					type: 'link',
					label: 'Ranking',
					link: 'step-counter/list'
				}
			]
		},
    {
      id: 'breathing-counter',
      type: 'dropdown',
      label: 'MÓDULO RESPIRAÇÃO',
      icon: 'fa-heart',
      dropdown: false,
      children: [
        {
          type: 'link',
          label: 'Relátorios',
          link: 'breathing-counter/report'
        },
        {
          type: 'link',
          label: 'Ranking',
          link: 'breathing-counter/list'
        }
      ]
    },
		{
			type: 'link',
			label: 'DESAFIOS',
			icon: 'fa-bullseye-arrow',
			link: 'campaigns',
			dropdown: false,
			hasChallengeEnabled: true,
			children: []
		},
		{
			type: 'dropdown',
			label: 'MÓDULO FLOW',
			icon: 'fa-heart-circle',
			dropdown: true,
      hasFlowEnabled: true,
			children: [
				{
					type: 'link',
					label: 'Resultados',
					icon: 'fa-file-chart-line',
					link: 'flow-nr1',
				},
				{
					type: 'link',
					label: 'Estatísticas COPSOQ',
					icon: 'fa-chart-bar',
					link: 'flow-nr1/charts'
				},
				{
					type: 'link',
					label: 'Questionário COPSOQ',
					icon: 'fa-clipboard-list-check',
					link: 'flow-nr1/questions'
				},
				{
					type: 'link',
					label: 'Ciclos',
					icon: 'fa-sync-alt',
					link: 'flow-nr1/cycles',
					justAdmin: true
				}
			]
		},
		{
			id: 'academy-module',
			type: 'dropdown',
			label: 'MÓDULO ACADEMY',
			icon: 'fa-graduation-cap',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Dashboard',
					link: 'academy/dashboard-company',
				}
			]
		},
		{
			id: 'health',
			type: 'dropdown',
			label: 'SAÚDE',
			icon: 'fa-file-medical',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Perfil da População',
					link: 'population'
				},
				{
					type: 'link',
					label: 'Riscos de Saúde',
					link: 'health-risks'
				},
				{
					type: 'link',
					label: 'Roda da Vida',
					link: 'wheel-of-life'
				},
				{
					type: 'link',
					label: 'Saúde Física',
					link: 'physical-health'
				},
				{
					type: 'link',
					label: 'Estresse e Motivação',
					link: 'stress-motivation'
				},
				{
					type: 'link',
					label: 'Questionário de Saúde',
					link: 'health-questionnaire'
				},
				{
					type: 'link',
					label: 'Covid-19',
					link: 'covid',
					hasCovidEnabled: true
				},
				{
					type: 'link',
					label: 'Comprovantes',
					link: 'proofs'
				}
			]
		},
		{
			id: 'app',
			type: 'dropdown',
			label: 'APLICATIVO',
			icon: 'fa-mobile',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Questionário de Saúde',
					link: 'health-quiz'
				},
				{
					type: 'link',
					label: 'Roda da Vida',
					link: 'life-wheel'
				},
				{
					type: 'link',
					label: 'Adesão à Plataforma',
					link: 'accession'
				},
				{
					type: 'link',
					label: 'Programas Gerais',
					link: 'programs'
				},
				{
					type: 'link',
					label: 'Eventos',
					link: 'events'
				},
				{
					type: 'link',
					label: 'Exames',
					link: 'exams'
				},
				{
					type: 'link',
					label: 'Vacinas',
					link: 'vaccine'
				},
				{
					type: 'link',
					label: 'Wellhub',
					link: 'wellhub',
					hasWellHubEnabled: true
				},
				{
					type: 'link',
					label: 'Academy',
					link: 'academy',
					justAdmin: true,
				},
				{
					type: 'link',
					label: 'Parceiros',
					link: 'businessPartner',
					hasBusinessPartnerEnabled: true
				},
				{
					type: 'link',
					label: 'Lojas',
					link: 'marketplace',
					hasMarketplaceEnabled: true
				},
				{
					type: 'link',
					label: 'Benefícios',
					link: 'benefits',
					hasBenefitsEnabled: true
				},
				{
					type: 'link',
					label: 'Atendimentos',
					link: 'appointment'
				},
				{
					type: 'link',
					label: 'Caminhada e Corrida',
					link: 'walkandrun'
				},
				{
					type: 'link',
					label: 'Mindfulness',
					link: 'mindfulness'
				},
				{
					type: 'link',
					label: 'Conteúdos',
					link: 'contents'
				},
				{
					type: 'link',
					label: 'FAQ',
					link: 'faq'
				}
			]
		},
		{
			id: 'notification',
			type: 'dropdown',
			label: 'NOTIFICAÇÃO',
			icon: 'fa-bell',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Dashboard',
					icon: 'fa-bell',
					link: 'notification/dashboard'
				},
				{
					type: 'link',
					label: 'Disparo',
					icon: 'fa-bell',
					link: 'notification/app'
				}
			]
		},
		{
			id: 'managent',
			type: 'dropdown',
			label: 'GESTÃO EMPRESA',
			icon: 'fa-users-cog',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Perfis de Elegíveis',
					link: 'eligible'
				},
				{
					type: 'link',
					label: 'Agendamentos',
					link: 'scheduling/list',
					hasServicesEnabled: true
				},
				{
					type: 'link',
					label: 'Inscrições em Eventos',
					link: 'subscribers/list',
					hasEventEnabled: true
				}
			]
		},
		{
			id: 'publications',
			type: 'dropdown',
			label: 'PUBLICAÇÕES',
			icon: 'fa-book-open',
			dropdown: false,
			children: [
				{
					type: 'link',
					label: 'Conteúdos',
					link: 'publications/contents'
				},
				{
					type: 'link',
					label: 'Informativos',
					link: 'publications/informatives',
					hasInformativesEnabled: true
				},
				{
					type: 'link',
					label: 'Eventos',
					link: 'publications/events',
					hasEventEnabled: true
				},
				{
					type: 'link',
					label: 'Banners',
					link: 'publications/banners'
				},
				{
					type: 'link',
					label: 'Wellhub',
					link: 'publications/wellhubs',
					hasWellHubEnabled: true
				},
				{
					type: 'link',
					label: 'Parceiros',
					link: 'publications/businessPartners',
					hasBusinessPartnerEnabled: true
				},
				{
					type: 'link',
					label: 'Lojas',
					link: 'publications/marketplaces',
					hasMarketplaceEnabled: true
				},
				{
					type: 'link',
					label: 'Benefícios',
					link: 'publications/benefits',
					hasBenefitsEnabled: true
				},
				{
					type: 'link',
					label: 'Programas',
					link: 'publications/programs'
				},
				{
					type: 'link',
					label: 'Academy',
					link: 'publications/academy',
					justAdmin: true,
				}
			]
		}
	];

	// Resolve the same authenticated profile as the route guard, independently of the layout's input.
	readonly canViewFloDashboard$ = this.sessionService.isAuthenticated().pipe(
		take(1),
		switchMap(authenticated => authenticated
			? this.sessionService.getUser().pipe(take(1), map(user => canViewFloDashboard(authenticated, user?.roles)))
			: of(false)),
		catchError(() => of(false))
	);

	constructor(public router: Router, public sidebarService: SidebarService, private sessionService: SessionService) { }

	ngOnInit() {
		this.validadeModuleMenu();

		this.updateSidebar();
		this.updateActiveMenu();
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(routeChange => {
			if (Utils.isMobile()) {
				this.sidebarService.active = false;
			}
			this.updateActiveMenu();
		});
	}

	validadeModuleMenu() {
		var universalStorage = new UniversalStorage();
		const hasOnlyFlowWebEnabled = universalStorage.getItem('hasOnlyFlowWebEnabled') === 'true';
		const hasCourseEnabled = universalStorage.getItem('hasCourseEnabled') === 'true';
		const hasOnlyAcademyWebEnabled = universalStorage.getItem('hasOnlyAcademyWebEnabled') === 'true';
		const isAdminType = universalStorage.getItem('IsAdminType') === 'true';
		const shouldShowAcademyModule = hasCourseEnabled || hasOnlyAcademyWebEnabled || isAdminType;
		//const shouldShowAcademyModule = isAdminType;

		if (isAdminType) {
			this.isAdmin = true;
		}

		if (universalStorage.getItem('hasLifeWellEnabled') === 'true') {
			if (universalStorage.getItem('IsOnlyManager') === 'true') {
				this.itemsMenu = this.itemsMenu.filter(item => item.label === 'USUÁRIOS');
			} else {
				this.itemsMenu = this.itemsMenu.filter(item => item.label === 'USUÁRIOS' || item.label === 'SAÚDE' || item.label === 'HOME');
			}
			this.itemsMenu.forEach(item => {
				if (item.children) {
					let index = item.children.findIndex(child => child.link === 'ranking-gamificacao');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					index = item.children.findIndex(child => child.link === 'users/vaccine');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					index = item.children.findIndex(child => child.link === 'proofs');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					if (universalStorage.getItem('hasCovidEnabled') !== 'true') {
						index = item.children.findIndex(child => child.hasCovidEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
				}
			})
		} else if (hasOnlyFlowWebEnabled) {

			this.itemsMenu = this.itemsMenu.filter(item => item.label === 'MÓDULO FLOW' || item.label === 'USUÁRIOS' || (hasCourseEnabled ? item.id === 'academy-module' : null) );
			this.itemsMenu.forEach(item => {
				if (item.children) {
					let index = item.children.findIndex(child => child.link === 'ranking-gamificacao');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					index = item.children.findIndex(child => child.link === 'users/vaccine');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					index = item.children.findIndex(child => child.link === 'users/managers');
					if (index !== -1) {
						item.children.splice(index, 1);
					}
					index = item.children.findIndex(child => child.link === 'users/user-covid');
					if (index !== -1) {
						item.children.splice(index, 1);
					}
          index = item.children.findIndex(child => child.link === 'users/list');
          if (index !== -1) {
            item.children.splice(index, 1);
          }
				}
			})

		} else if (hasOnlyAcademyWebEnabled) {
			this.itemsMenu = this.itemsMenu.filter(item => item.label === 'USUÁRIOS' || (shouldShowAcademyModule ? item.id === 'academy-module' : null));

			this.itemsMenu.forEach(item => {
				if (item.children) {
					let index = item.children.findIndex(child => child.link === 'ranking-gamificacao');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					index = item.children.findIndex(child => child.link === 'users/vaccine');
					if (index !== -1) {
						item.children.splice(index, 1);
					}

					index = item.children.findIndex(child => child.link === 'users/managers');
					if (index !== -1) {
						item.children.splice(index, 1);
					}
					index = item.children.findIndex(child => child.link === 'users/user-covid');
					if (index !== -1) {
						item.children.splice(index, 1);
					}
				}
			})

		} else {
			this.itemsMenu.forEach(item => {
				if (item.children) {
					if (universalStorage.getItem('hasBenefitsEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasBenefitsEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasWellHubEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasWellHubEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasBusinessPartnerEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasBusinessPartnerEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasMarketplaceEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasMarketplaceEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasCovidEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasCovidEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasBannerEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasBannerEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasInformativesEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasInformativesEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasServicesEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasServicesEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasEventEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasEventEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
					if (universalStorage.getItem('hasCourseEnabled') !== 'true') {
						const index = item.children.findIndex(child => child.hasCourseEnabled === true);
						if (index !== -1) {
							item.children.splice(index, 1);
						}
					}
				}

				if (universalStorage.getItem('hasChallengeEnabled') !== 'true') {
					this.itemsMenu = this.itemsMenu.filter(item => item.hasChallengeEnabled !== true);
				}
				if (universalStorage.getItem('hasFlowEnabled') !== 'true') {
					this.itemsMenu = this.itemsMenu.filter(item => item.hasFlowEnabled !== true);
				}

				if (universalStorage.getItem('IsOnlyManager') === 'true') {
					this.itemsMenu = this.itemsMenu.filter(item => item.label === 'USUÁRIOS');
				}
			});
		}

		if (!shouldShowAcademyModule) {
			this.itemsMenu = this.itemsMenu.filter(item => item.id !== 'academy-module');
		}

	}
	updateSidebar() {
		this.sidebarService.active = !Utils.isMobile();
		this.isMobile = !Utils.isMobile();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.updateSidebar();
	}

	setActiveMenu(item) {
		setTimeout(() => {
			item.dropdown = !item.dropdown;
		}, 0);
	}

	private updateActiveMenu() {
		const activeRoute = window.location.hash || window.location.pathname;
		this.itemsMenu.forEach(item => {
			item.dropdown = false;
			if (activeRoute.indexOf(item.link) !== -1) {
				item.dropdown = true;
			}
			if (item.children) {
				item.children.forEach(subItem => {
					//subItem.active = false;
					if (activeRoute.indexOf("/painel/" + subItem.link) !== -1) {
						item.dropdown = true;
					}
				});
			}
		});
	}

	toggleSidebar() {
		this.sidebarService.minSidebar = !this.sidebarService.minSidebar;
	}
}
